var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { version } from "@hyper-hyper-space/hhs3_mvt";
export function resolveVersionRef(session, text, objectId) {
    return __awaiter(this, void 0, void 0, function* () {
        const trimmed = text.trim();
        if (trimmed.toLowerCase() === 'latest') {
            return frontierForObjectId(session, objectId);
        }
        if (trimmed.startsWith('#')) {
            const hash = yield session.workspace.roots.resolveHash({ kind: 'hash', prefix: trimmed.slice(1), span: { start: 0, end: trimmed.length, line: 1, column: 1 } }, { kind: 'object', objectId });
            return version(hash);
        }
        const hash = session.aliases.get('version', trimmed);
        if (hash === undefined)
            throw new Error(`Unknown version ref '${trimmed}'`);
        yield assertHashInScopedDag(session, hash, { kind: 'object', objectId });
        return version(hash);
    });
}
export function resolveVersionMember(session, member, hashScope) {
    return __awaiter(this, void 0, void 0, function* () {
        if (member.kind === 'hash') {
            return session.workspace.roots.resolveHash(member, hashScope);
        }
        const hash = session.aliases.get('version', member.text);
        if (hash === undefined)
            throw new Error(`Unknown version alias '${member.text}'`);
        yield assertHashInScopedDag(session, hash, hashScope);
        return hash;
    });
}
export function assertHashInScopedDag(session, hash, hashScope) {
    return __awaiter(this, void 0, void 0, function* () {
        const candidates = yield session.workspace.roots.hashCandidates(hashScope);
        if (!candidates.includes(hash)) {
            throw new Error(`Version alias hash '${hash}' is not in this object's history`);
        }
    });
}
export function frontierForScope(scope) {
    return __awaiter(this, void 0, void 0, function* () {
        const object = scope.kind === 'schema'
            ? scope.schema
            : scope.kind === 'group'
                ? scope.group
                : scope.kind === 'table'
                    ? scope.table
                    : scope.object;
        if (object === undefined)
            return version();
        return (yield object.getScopedDag()).getFrontier();
    });
}
export function hashScopeForVersionScope(scope) {
    if (scope.kind === 'schema')
        return { kind: 'object', objectId: scope.id };
    if (scope.kind === 'group')
        return { kind: 'object', objectId: scope.id };
    if (scope.kind === 'table')
        return { kind: 'object', objectId: scope.groupId };
    return { kind: 'object', objectId: scope.id };
}
function frontierForObjectId(session, objectId) {
    return __awaiter(this, void 0, void 0, function* () {
        const root = session.workspace.roots.get(objectId);
        const object = root === null || root === void 0 ? void 0 : root.object;
        if (object === undefined)
            throw new Error(`Object '${objectId}' is not loaded`);
        return (yield object.getScopedDag()).getFrontier();
    });
}
